import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import SingleProcessor from '../../components/Single.vue';
export default {
  __name: 'SinglePage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "单张图片处理",
        "current-page": "single"
      }, {
        default: _withCtx(() => [_createVNode(SingleProcessor)]),
        _: 1
      });
    };
  }
};